<template>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-sm-2">

        <label>Cd Opeda</label>

        <b-form-group :invalid-feedback="violations['cdOpeda']" :state="!violations['']">

          <b-form-input v-model="ssv2300ConfiOpedaWs.cdOpeda" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Ds Opeda</label>

        <b-form-group :invalid-feedback="violations['dsOpeda']" :state="!violations['']">

          <b-form-input v-model="ssv2300ConfiOpedaWs.dsOpeda" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Cd Senha Opeda</label>

        <b-form-group :invalid-feedback="violations['cdSenhaOpeda']" :state="!violations['']">

          <b-form-input v-model="ssv2300ConfiOpedaWs.cdSenhaOpeda" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Dt Psi</label>

        <b-form-group :invalid-feedback="violations['dtPsi']" :state="!violations['']">

          <date-picker v-model="ssv2300ConfiOpedaWs.dtPsi" type="date" value-type="format" lang="pt-br" format="DD/MM/YYYY" placeholder="" :required="false" :readonly="false"></date-picker>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Ic Opeda Libra</label>

        <b-form-group :invalid-feedback="violations['icOpedaLibra']" :state="!violations['']">

          <b-form-input v-model="ssv2300ConfiOpedaWs.icOpedaLibra" type="text" placeholder="" :required="false" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Tp Opeda</label>

        <b-form-group :invalid-feedback="violations['tpOpeda']" :state="!violations['']">

          <select class="custom-select" v-model="ssv2300ConfiOpedaWs.tpOpeda" placeholder="" :required="true" :readonly="false">
            <option></option>

            <option value="Corretor">C</option>

            <option value="Integradora">I</option>

            <option value="Teste">F</option>

          </select>

        </b-form-group>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import store from "@/store";
  
  import { 
  	
      } from "@/store/actions.type";
      
  export default {
    props: ['ssv2300ConfiOpedaWs', 'violations'],
    computed: {
  	    ...mapGetters([
  	         
  	         ]),
    },
    methods:{
        
    },
    mounted(){
      
    }
  }
</script>